import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { useEffect } from "react";

const ProtectedRoutes = () => {
  const isLogged = useSelector((state) => state.auth.isLogged, shallowEqual)

  useEffect(() => {
    console.log("isLogged", isLogged)
  });
  // If authorized, return an outlet that will render child elements
  // If not, return element that will navigate to login page
  return isLogged ? <Outlet /> : <Navigate to="/login" />;
};
export default ProtectedRoutes;
